import React from 'react';
import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS from '../../../projects/REQUIRED_FIELDS';
import { site_state_$ilike } from '../../../../utils/query-helpers';

export default function useProjectStudentImpact(network, schoolStart, schoolEnd, state) {
  const projects = useConnect('project.find', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          // networkId: network?.id,
          ...site_state_$ilike(state),
          completed: true,
          students: {
            $gte: 0
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  });

  const totalCount = _.reduce(projects.data, function(result, project) {
    return result + project.data.students;
  }, 0);

  return [
    projects,
    totalCount
  ];
}
